module.exports = __webpack_public_path__ + "img/lightDecoration.6cc639e0.jpg";